'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DEFAULT_BUTTON_TYPE = exports.DEFAULT_BUTTON_TYPE = 'button-small';
var DEFAULT_BUTTON_COLOR = exports.DEFAULT_BUTTON_COLOR = 'action-1';
var DEFAULT_TEST_ID = exports.DEFAULT_TEST_ID = 'button';
var DEFAULT_EXPAND_ICON = exports.DEFAULT_EXPAND_ICON = 'arrow-down';
var DEFAULT_DIRECT_ICON = exports.DEFAULT_DIRECT_ICON = 'arrow-right';
var BUTTON = exports.BUTTON = 'button';
var CONTENT_LEFT = exports.CONTENT_LEFT = 'l';
var CONTENT_RIGHT = exports.CONTENT_RIGHT = 'r';
var FULL = exports.FULL = 'full';
var LIGHT = exports.LIGHT = 'light';
var FULL_WIDTH = exports.FULL_WIDTH = 'fw';
var WITH_SHADOW = exports.WITH_SHADOW = 'shadow';
var WITH_ICON = exports.WITH_ICON = 'icon';
var SMALL = exports.SMALL = 'small';
var BIG = exports.BIG = 'big';
var SECONDARY = exports.SECONDARY = 'secondary';
var EXPAND = exports.EXPAND = 'expand';
var DIRECT = exports.DIRECT = 'direct';
var SPLIT_SEPARATOR = exports.SPLIT_SEPARATOR = '-';
var getButtonName = function getButtonName(strings) {
    return strings.join(SPLIT_SEPARATOR);
};
var buttonTypes = exports.buttonTypes = {
    smallButton: getButtonName([BUTTON, SMALL]),
    smallButtonIconLeft: getButtonName([BUTTON, SMALL, WITH_ICON, CONTENT_LEFT]),
    smallButtonIconRight: getButtonName([BUTTON, SMALL, WITH_ICON, CONTENT_RIGHT]),
    bigButton: getButtonName([BUTTON, BIG]),
    bigButtonIconLeft: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_LEFT]),
    bigButtonIconRight: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_RIGHT]),
    bigButtonWithShadow: getButtonName([BUTTON, BIG, WITH_SHADOW]),
    bigButtonFullWidth: getButtonName([BUTTON, BIG, FULL_WIDTH]),
    bigButtonFullWidthWithShadow: getButtonName([BUTTON, BIG, FULL_WIDTH, WITH_SHADOW]),
    bigButtonIconLeftFullWidth: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_LEFT, FULL_WIDTH]),
    bigButtonIconRightFullWidth: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_RIGHT, FULL_WIDTH]),
    bigButtonIconLeftFullWidthWithShadow: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_LEFT, FULL_WIDTH, WITH_SHADOW]),
    bigButtonIconRightFullWidthWithShadow: getButtonName([BUTTON, BIG, WITH_ICON, CONTENT_RIGHT, FULL_WIDTH, WITH_SHADOW]),
    secondaryButtonLight: getButtonName([BUTTON, SECONDARY, LIGHT]),
    secondaryButtonLightWithIcon: getButtonName([BUTTON, SECONDARY, WITH_ICON, LIGHT]),
    secondaryButtonFull: getButtonName([BUTTON, SECONDARY, FULL]),
    expandButton: getButtonName([BUTTON, SECONDARY, EXPAND]),
    directButton: getButtonName([BUTTON, SECONDARY, DIRECT])
};
var buttonColors = exports.buttonColors = {
    action1: 'action-1',
    action2: 'action-2',
    black: 'black',
    neutral: 'neutral'
};
//# sourceMappingURL=button.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/data/button.js
// module id = 977
// module chunks = 0